<template>
  <div class="home">
    <Header msg="Welcome to Your Vue.js App" />
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->

    <!-- 右侧菜单栏 -->
    <div v-if="$route.meta.showChild" class="sticky">
      <Navhead />
    </div>

    <!-- 页面 -->
    <div class="roufind" v-if="!$route.meta.navLeft&&!$route.meta.corporateCulture" >
      <Breadcrumb v-if="$route.meta.hideInBreadcrumb"/>
    <router-view />
    </div>
    



    <!-- 会员中心左侧菜单栏 -->
    <div class="headbox_f" v-if="$route.meta.navLeft">
      <Breadcrumb />
      <div class="foot_box">
        <NavLeftList />
        <router-view />
      </div>
    </div>

     <!-- 企业文化左侧菜单栏 -->
     <div class="headbox_f" v-if="$route.meta.corporateCulture">
      <Breadcrumb :add="true"/>
      <div class="foot_box">
        <NavLeftCulture />
        <router-view />
      </div>
    </div>

    <Footer />
  </div>
</template>
  
<script>
// import HelloWorld from '@/components/HelloWorld.vue';
import Header from '@/components/header.vue';
import Footer from '@/components/Footer.vue';
import Navhead from '@/components/navhead.vue';
import NavLeftList from '@/components/navLeftList.vue';
import NavLeftCulture from '@/components/navLeftCulture.vue';
import Breadcrumb from '@/components/breadcrumb.vue';

export default {
  name: 'HomeView',
  components: {
    // HelloWorld,
    Header,
    Footer,
    Navhead,
    NavLeftList,
    NavLeftCulture,
    Breadcrumb
  },
};
</script>
<style lang="less">
.home {
  position: relative;
  display: flow-root;
  padding-top: 232px;
}
.roufind{
  display: flow-root;
  background-color: #F5F5F5;
  
}
.sticky {
  position: sticky;
  top: 150px;

  // right: 50px;
}

.headbox_f {
  background-color: #F5F5F5;
  padding: 10px 0;

  .foot_box {
    display: flex;
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto;
  }
}
</style>
  